import http from './http';

export interface AuthorizedPerson {
  name: string;
  relationship: string;
  email?: string;
}

export interface HealthcareProvider {
  name: string;
  type: string;
  phone?: string;
}

export interface HIPAAAuthorizationData {
  id?: string;
  authorizedPersons?: AuthorizedPerson[];
  healthcareProviders?: HealthcareProvider[];
  additionalRestrictions?: string;
  authorizationDate?: string;
  expirationDate?: string;
  isLocked?: boolean;
}

class HIPAAAuthorizationService {
  async createHIPAAAuthorization(data: Omit<HIPAAAuthorizationData, 'id'>): Promise<HIPAAAuthorizationData> {
    const response = await http.post('/api/hipaa-authorization', data);
    return response.data.data || response.data;
  }

  async updateHIPAAAuthorization(id: string, data: Partial<HIPAAAuthorizationData>): Promise<HIPAAAuthorizationData> {
    const response = await http.patch(`/api/hipaa-authorization/${id}`, data);
    return response.data.data || response.data;
  }

  async getHIPAAAuthorizationById(id: string, targetUserId?: string): Promise<HIPAAAuthorizationData> {
    const url = targetUserId
      ? `/api/hipaa-authorization/${id}?targetUserId=${targetUserId}`
      : `/api/hipaa-authorization/${id}`;
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async getAllHIPAAAuthorizations(targetUserId?: string): Promise<HIPAAAuthorizationData[]> {
    const url = targetUserId
      ? `/api/hipaa-authorization?targetUserId=${targetUserId}`
      : '/api/hipaa-authorization';
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async deleteHIPAAAuthorization(id: string): Promise<void> {
    await http.delete(`/api/hipaa-authorization/${id}`);
  }

  async lockHIPAAAuthorization(id: string): Promise<void> {
    await http.post(`/api/hipaa-authorization/${id}/lock`);
  }

  async unlockHIPAAAuthorization(id: string, granteeEmails: string[]): Promise<void> {
    await http.post(`/api/hipaa-authorization/${id}/unlock`, { granteeEmails });
  }

  async getHIPAAAuthorizationAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/hipaa-authorization/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const hipaaAuthorizationService = new HIPAAAuthorizationService();
